export const Preferences = {
    Title: 'Application Preferences',
    PersonalInfo:
    {
        Title: 'Personal Info',
        Inputs: {
            Avatar: {
                placeholder: 'Click here to select an avatar'
            },
            FirstName: {
                placeholder: 'First name'
            },
            LastName: {
                placeholder: 'Last name'
            },
            Phone: {
                placeholder: 'Your telephone number'
            },
            Email: {
                placeholder: 'Enter your email address'
            }
        },
        Buttons: {
            UpdatePersonalInfo: {
                label: 'Update Personal Info'
            }
        },
        Errors: {
            Avatar: 'Please select a profile picture.',
            FirstName: 'Please enter your first name.',
            LastName: 'Please enter your last name.',
            Email: 'Please enter your email address.',
            Phone: 'Please enter a valid telephone number.'
        }
    },
    Password: {
        Title: 'Password',
        Inputs: {
            Password: {
                placeholder: 'Enter current password'
            },
            NewPassword: {
                placeholder: 'Enter new password'
            },
            NewPasswordConfirm: {
                placeholder: 'Re-enter new password'
            }
        },
        Buttons: {
            UpdatePassword: {
                label: 'Update Password'
            }
        },
        Errors: {
            Password: 'Password should be 8 characters long and contain a number.',
            ConfirmPassword: 'Passwords do not match.'
        }
    },
    Notifications: {
        Title: 'Notifications',
        Inputs: {
            Checkbox: 'Receive SMS Notifications'
        }
    },
    CardInfo: {
        Title: 'Card Info',
        Inputs: {
            CardNumber: {
                placeholder: 'Payment Card Number'
            },
            CardExpirationDate: {
                placeholder: 'MM/YY'
            },
            CardCVV: {
                placeholder: 'CVV'
            }
        },
        Buttons: {
            UpdateCardInfo: {
                label: 'Update Card Info'
            }
        },
        Errors: {
            CardNumber: 'Card number is invalid',
            ExpirationDate: 'Expire date is invalid. Enter with format: \'MM/YY\'',
            CVV: 'CVV is invalid'
        }
    },
    Messages: {
        Titles: {
            Avatar: 'Profile picture',
            PersonalInfo: 'Personal Info',
            Password: 'Password',
            CardInfo: 'Card Info',
            SMS: 'SMS Notifications'
        },
        Content: {
            AvatarUploadSuccess: 'Picture updated',
            PersonalInfoUpdateSuccess: 'Preferences updated successfully',
            PasswordUpdateSuccess: 'Password was updated',
            CardInfoUpdateSuccess: 'Card Info was updated successfully',
            SmsSuccess: 'SMS notifications was updated successfully'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/Preferences.ts